import React, { useState, useEffect, useRef, useCallback } from "react";
import { getLocationByLatLang, validateLatitude, validateLongititu } from "../../../Utils/utils/CommanFnc";
import { type } from "@testing-library/user-event/dist/type";

export function Maps(props) {
  const userLatLangList = props.data?.userLatLangList
  const [center, setCenter] = useState({});
  const zoom = 5;
  const inputEl = useRef();

  function success(pos) {
    const crd = pos.coords;
     setCenter({ lat: parseFloat(crd.latitude), lng: parseFloat(crd.longitude) })
  }
  
  function error(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  }

  const getCurrentLocation = useCallback( ()=>{
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    navigator.geolocation.getCurrentPosition(success, error, options);
  },[])  

  function renderInfoWindow({marker, place, map, infowindow, infowindowContent, shopName}) {
    if(infowindow){
      const placeName = place?.name || place?.address_components?.[0]?.['long_name']
      const fullAddress = `<b> ${shopName}</b> <br/> ${placeName} <br/> ${place.formatted_address}`
      infowindow.setContent(fullAddress)
      infowindow.open(map, marker);
    }
  }

  function toggleBounding(marker) {
    if (marker.getAnimation() !== null) {
        marker.setAnimation(null);
      } else {
        marker.setAnimation(window.google.maps.Animation.BOUNCE);
      }
  }

  const initMap = useCallback( () => {
  
      try{
        const map = new window.google.maps.Map(inputEl.current, {
          center,
          zoom,
          mapTypeId: window.google.maps.MapTypeId.ROADMAP,
          mapTypeControl: false,
          navigationControlOptions: { 
            style: window.google.maps.NavigationControlStyle.SMALL 
          }
        });
        const infowindow = new window.google.maps.InfoWindow();
        const infowindowContent = document.getElementById("infowindow-content");
        userLatLangList.forEach((item) => {
          if((!isNaN(item['latitude']) && !isNaN(item['longitude'])) && (validateLatitude(item['latitude']) && validateLongititu(item['longitude']))){
            const markerOpt = {
              position: new window.google.maps.LatLng(parseFloat(item['latitude']), parseFloat(item['longitude'])),
              map: map,
              animation: window.google.maps.Animation.DROP,
            } 
            const marker = new window.google.maps.Marker(markerOpt);
            marker.addListener("click", () => {
              infowindow.open(map, marker);
              toggleBounding(marker);
              getLocationByLatLang({lat: parseFloat(item['latitude']), lng: parseFloat(item['longitude'])}).then((place)=>{
                infowindow.setContent(infowindowContent);
                renderInfoWindow({marker, place, map, infowindow, infowindowContent, shopName: item['shopName']})
              })
            });
          }
        })
      }catch(error){
        console.log(error)
      }
  },[center, userLatLangList])

  useEffect(() => {
    setTimeout(()=>{
      getCurrentLocation()
    },100)
  }, [getCurrentLocation]);

  useEffect(() => {
    if(Object.keys(center).length > 0){
      setTimeout(()=>{
        initMap()
      }, 100)
    }
  }, [center, initMap, userLatLangList]);

  return (
   <>
    <div className="row">
    <div ref={inputEl} id="map" className="col-sm-12 mb-5" style={{
          width: "100%",
          border: "1px solid #efebeb",
          boxShadow: "0px 0px 9px 0px",
          borderRadius: "5px",
          height: "calc(80vh - 150px)"
        }}/>
      </div>
   </>
  );
}